import HeatMapViz from '../vizs/HeatMapViz'
import BaseComponent from './BaseComponent'
/**
 * {-EN-}
 * # {componentLabel} (`class {componentClassName}`)
 * A HeatMap is used to display the magnitude of a phenomenon as color in two dimensions. The variation in color may be by hue or intensity, giving obvious visual cues to the reader about how the phenomenon is clustered or varies over space.
 *
 * ### Example Usage
 * ```javascript
 *
 *   import {HeatMap} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new HeatMap($el, data, config);
 *
 * ```
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with exactly 3 columns.
 *
 * Each row represents a cell in the chart. The first two columns should represent the coordinates (x and y) and the third columnd should represent the value/color.
 *
 * Note: the x and y coordinates can be numebers or strings, and will be sorted in the orther in which they appear in the table.
 *
 * |     |  x    | y    |  color   |
 * |  ----  | ------| ---  |  ------  |
 * |  1    |   a   |     A|      15.4|
 * |  2    |   a   |     B|      29.3|
 * |  3    |   a   |     C|      34.1|
 * |  4    |   b   |     A|      12.3|
 * |  5    |   b   |     B|      12.3|
 * |  6    |   b   |     C|      12.3|
 * |  7   |   c   |     A|      12.3|
 * |  8    |   c   |     B|      12.3|
 * |  9   |   c   |     C|      12.3|
 *
 * {.data-table}
 *
 * {-ES-}
 * # {componentLabelEs} (`class {componentClassName}`)
 * Un HeatMap se utiliza para mostrar la magnitud de un fenómeno en forma de color en dos dimensiones. La variación de color puede ser por tono o intensidad, dando pistas visuales obvias al lector sobre cómo el fenómeno se agrupa o varía en el espacio.
 *
 * ### Ejemplo de uso
 * ```javascript
 *
 *   import {HeatMap} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new HeatMap($el, data, config);
 *
 * ```
 *
 * ### Estructura de datos {.section-data-structure}
 * Los datos tabulares de este gráfico deben ser una tabla con exactamente 3 columnas.
 *
 * Cada fila representa una celda del gráfico. Las dos primeras columnas deben representar las coordenadas (x e y) y la tercera columna debe representar el valor/color.
 *
 * Nota: las coordenadas xey pueden ser números o cadenas, y se ordenarán en el orden en que aparecen en la tabla.
 *
 * |     |  x    | y    |  color   |
 * |  ----  | ------| ---  |  ------  |
 * |  1    |   a   |     A|      15.4|
 * |  2    |   a   |     B|      29.3|
 * |  3    |   a   |     C|      34.1|
 * |  4    |   b   |     A|      12.3|
 * |  5    |   b   |     B|      12.3|
 * |  6    |   b   |     C|      12.3|
 * |  7   |   c   |     A|      12.3|
 * |  8    |   c   |     B|      12.3|
 * |  9   |   c   |     C|      12.3|
 *
 * {.data-table}
 * */
export default class HeatMapComponent extends BaseComponent {
  static vizClass = HeatMapViz
  static componentLabel = 'Heat map'
  static componentLabelEs = "Mapa de calor"
  static dataFormat = [
    {
      index: 0,
      axis: 'x0',
      label: 'x category',
      //TODO revisar este types Number por que da problemas de 'wrong type' en editor de datos
      //types: [String, Number],
      types: [String],
      role: 'partial-id',
      roleLabel: 'X category',
    },
    {
      index: 1,
      axis: 'y0',
      label: 'y category',
      //TODO revisar este types Number por que da problemas de 'wrong type' en editor de datos
      //types: [String, Number],
      types: [String],
      role: 'partial-id',
      roleLabel: 'Y category',
    },
    { index: 2, axis: '', label: 'color', types: [Number], role: 'value', roleLabel: 'Value' },
  ]
  static defaultConfig = {
    title: this.componentLabel,
    TooltipBehavior: {
      tooltipValueFormat: {
        exposed: true,
        nonEditable: false,
      },
    },
  }
  static dataRequirements = {
    // forzamos que HAYA ids repetidos para que no sea un heatmap con SOLO la diagonal...
    customMultiplier: rows => {
      let counts = rows.reduce((counts, row) => {
        row.forEach((cell, i) => {
          counts[i] = counts[i] || {}
          counts[i][cell] = counts[i][cell] || 0
          counts[i][cell] += 1
        })
        return counts
      }, [])
      let repeats = counts.map(c => Object.values(c)).flat()
      return repeats.find(r => r > 1) ? 1 : 0
    },
  }
}
